import {Project} from './project';
import {TtmStatus} from './ttmstatus';
import {TtmType} from './ttmtype';
import {Workorder} from './workorder';
import {Entity} from './entity';
import {TtmTypes} from './ttm-types.enum';

export class Ttm {
    id: number;
    project_id: number;
    status_key: string;
    status_date?: Date;
    comment?: string;
    comment_show_on_status_change?: boolean;
    comment_show_on_map?: boolean;
    amount?: number;
    amount_changed?: boolean;
    order?: Project;
    status?: TtmStatus;
    type?: TtmType;
    type_key?: TtmTypes;
    weighting_one?: boolean;
    weighting_two?: boolean;
    weighting_three?: boolean;
    workorders?: Workorder[];
    entities?: Entity[];
    ttm_images_count?: number;
}
